import {Controller} from "@hotwired/stimulus"
import {end} from "@popperjs/core";
import Cleave from 'cleave.js';

// Connects to data-controller="operatorinfo"
export default class extends Controller {
  static targets = [
    "permanent", "scale",
    "stateStatus", "lowDate",
    "comision", "operatorBilledComision",
    "isactivedadvancedbilling", "advance", "advanceHidden", "advanceActive", "advanceConsumedAmount",
    "buttonLenguage", "inputLenguage",
    "buttonState", "inputState",
    "buttonBone", "inputBone",
    "buttonRenueve", "inputRenueve",
    "buttonScaling", "inputScaling",
    "buttonScalingBasis", "inputScalingBasis",
    "generalData", "commercialTerms", "billing", "renewals", "buttonView",
    "scrollButton",
    "bonosporcontrato", "bonocampingprice", "tasadgoj", "initialAmount", "finalAmount", "rsPercentage", "mingaran", "hostingfijo", "comision", "advanceAmount", "consumedAdvance",
    "createAccount", "emailField"
  ]

  connect() {
    if (this.hasStateStatusTarget) {
      this.stateStatusTarget.addEventListener("change", this.toggleDateFieldState.bind(this))
      this.toggleDateFieldState();
    }

    if (this.hasInputRenueveTarget) {
      this.toggleDateFieldRenueveShare();
      this.updateRenueveButtons(this.inputRenueveTarget.value);
    }

    if (this.hasInputLenguageTarget) {
      this.updateLanguageButtons(this.inputLenguageTarget.value);
    }

    if (this.hasInputStateTarget) {
      this.updateStateButtons(this.inputStateTarget.value);
    }

    if (this.hasInputBoneTarget) {
      this.updateBoneButtons(this.inputBoneTarget.value);
    }

    if (this.hasIsactivedadvancedbillingTarget) {
      this.checkAdvancedBilling();
    }

    if (this.isEditMode()) {
      this.initializeAllForms();
    }

    if (this.hasButtonViewTarget) {
      this.updateViewButtons('general-data');
    }

    if (this.hasGeneralDataTarget) {
      this.showView('generalData');
    }

    if (this.hasScrollButtonTarget) {
      this.checkScroll();
      window.addEventListener("scroll", () => {
        this.checkScroll();
      });
    }

    const cleaveTargets = [
      "bonosporcontrato", "bonocampingprice", "tasadgoj", "initialAmount", "finalAmount", "rsPercentage", "mingaran", "hostingfijo", "comision", "advanceAmount", "consumedAdvance"
    ];

    cleaveTargets.forEach(target => {
      const hasTargetFunction = `has${target.charAt(0).toUpperCase() + target.slice(1)}Target`;
      if (this[hasTargetFunction]) {
        const inputElement = this[target + "Target"];
        // Store the current value and convert decimal point to comma if needed
        const currentValue = inputElement.value;
        const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
        
        new Cleave(inputElement, {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.'
        });
        
        // Set the formatted value after Cleave initialization
        if (formattedValue) {
          inputElement.value = formattedValue;
        }
      }
    });

    this.element.addEventListener('submit', this.validateEmail.bind(this));

  }

  disconnect() {
    if (this.hasStateStatusTarget) {
      this.stateStatusTarget.removeEventListener("change", this.toggleDateFieldState.bind(this))
    }
  }

  toggleDateFieldRenueveShare() {
    if (this.inputRenueveTarget.value === "with_scaling") {
      this.scaleTarget.classList.remove("hidden");
      this.permanentTarget.classList.add("hidden");
      this.permanentTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });


    } else if (this.inputRenueveTarget.value === "permanent") {

      const forms = document.querySelectorAll('.form_scaling');
      forms.forEach(form => {
        form.remove();
      });

      this.scaleTarget.classList.add("hidden");
      this.permanentTarget.classList.remove("hidden");

      this.scaleTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.scaleTarget.querySelectorAll("select").forEach((select) => {
        select.selectedIndex = 0;
      });

    } else {
      this.scaleTarget.classList.add("hidden");
      this.permanentTarget.classList.add("hidden");
      this.scaleTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.scaleTarget.querySelectorAll("select").forEach((select) => {
        select.selectedIndex = 0;
      });
      this.permanentTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
    }
  }

  toggleDateFieldState() {
    if (this.inputStateTarget.value === "low") {
      this.lowDateTarget.classList.remove("hidden")
    } else {
      this.lowDateTarget.classList.add("hidden")
      this.lowDateTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
    }
  }

  checkComision() {
    if (parseFloat(this.comisionTarget.value) > 0) {
      this.operatorBilledComisionTarget.disabled = false;
      this.operatorBilledComisionTarget.classList.remove("bg-gray-300")
    } else {
      this.operatorBilledComisionTarget.disabled = true;
      this.operatorBilledComisionTarget.classList.add("bg-gray-300")
      this.operatorBilledComisionTarget.checked = false;
    }
  }

  checkAdvancedBilling() {
    if (this.isactivedadvancedbillingTarget.checked) {
      this.advanceTarget.classList.remove("hidden")
    } else {
      this.advanceTarget.classList.add("hidden")
      this.advanceTarget.querySelectorAll("input").forEach((input) => {
        input.value = '';
      });
      this.advanceTarget.querySelector("input[type='checkbox']").checked = false;
    }
  }

  changeLanguage(event) {
    event.preventDefault();
    let selectedLanguage = event.currentTarget.dataset.language;
    this.updateLanguageButtons(selectedLanguage);
    this.inputLenguageTarget.value = selectedLanguage;
  }

  updateLanguageButtons(selectedLanguage) {
    this.buttonLenguageTargets.forEach((button) => {
      if (button.dataset.language === selectedLanguage) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeState(event) {
    event.preventDefault();
    let selectedState = event.currentTarget.dataset.state;
    this.updateStateButtons(selectedState);
    this.inputStateTarget.value = selectedState;
    this.toggleDateFieldState();
  }

  updateStateButtons(selectedState) {
    this.buttonStateTargets.forEach((button) => {
      if (button.dataset.state === selectedState) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeBone(event) {
    event.preventDefault();
    let selectedBone = event.currentTarget.dataset.state;
    this.updateBoneButtons(selectedBone);
    this.inputBoneTarget.value = selectedBone;
  }

  updateBoneButtons(selectedBone) {
    this.buttonBoneTargets.forEach((button) => {
      if (button.dataset.state === selectedBone) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeRenueve(event) {
    event.preventDefault();
    let selectedRenueve = event.currentTarget.dataset.state;
    this.updateRenueveButtons(selectedRenueve);
    this.inputRenueveTarget.value = selectedRenueve;
    this.toggleDateFieldRenueveShare();
  }

  updateRenueveButtons(selectedRenueve) {
    this.buttonRenueveTargets.forEach((button) => {
      if (button.dataset.state === selectedRenueve) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeScaling(event) {
    event.preventDefault();

    const formContainer = event.currentTarget.closest('.m-2');

    if (!formContainer) {
      console.error('Contenedor del formulario no encontrado');
      return;
    }

    let selectedScaling = event.currentTarget.dataset.state;
    this.updateScalingButtons(selectedScaling, formContainer);
    let inputScaling = formContainer.querySelector('[data-operatorinfo-target="inputScaling"]');
    if (inputScaling) {
      inputScaling.value = selectedScaling;
    }
  }

  updateScalingButtons(selectedScaling, formContainer) {
    const buttons = formContainer.querySelectorAll('[data-operatorinfo-target="buttonScaling"]');

    buttons.forEach((button) => {
      if (button.dataset.state === selectedScaling) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeScalingBasis(event) {
    event.preventDefault();

    const formContainer = event.currentTarget.closest('.m-2');

    if (!formContainer) {
      console.error('Contenedor del formulario no encontrado');
      return;
    }

    let selectedScalingBasis = event.currentTarget.dataset.state;
    this.updateScalingBasisButtons(selectedScalingBasis, formContainer);
    let inputScalingBasis = formContainer.querySelector('[data-operatorinfo-target="inputScalingBasis"]');
    if (inputScalingBasis) {
      inputScalingBasis.value = selectedScalingBasis;
    }
  }

  updateScalingBasisButtons(selectedScalingBasis, formContainer) {
    const buttons = formContainer.querySelectorAll('[data-operatorinfo-target="buttonScalingBasis"]');

    buttons.forEach((button) => {
      if (button.dataset.state === selectedScalingBasis) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  changeView(event) {
    event.preventDefault();
    let selectedView = event.currentTarget.dataset.view;

    this.updateViewButtons(selectedView);

    switch (selectedView) {
      case 'general-data':
        this.showView('generalData');
        break;
      case 'commercial-terms':
        this.showView('commercialTerms');
        break;
      case 'billing':
        this.showView('billing');
        break;
      case 'renewals':
        this.showView('renewals');
        break;
    }
  }

  showView(viewName) {
    this.generalDataTarget.classList.add("opacity-0");
    this.commercialTermsTarget.classList.add("opacity-0");
    this.billingTarget.classList.add("opacity-0");
    this.renewalsTarget.classList.add("opacity-0");

    setTimeout(() => {
      this.generalDataTarget.classList.add("hidden");
      this.commercialTermsTarget.classList.add("hidden");
      this.billingTarget.classList.add("hidden");
      this.renewalsTarget.classList.add("hidden");

      this[viewName + 'Target'].classList.remove("hidden");
      setTimeout(() => {
        this[viewName + 'Target'].classList.remove("opacity-0");
      }, 35);
    }, 300);
  }


  updateViewButtons(selectedView) {
    this.buttonViewTargets.forEach((button) => {
      if (button.dataset.view === selectedView) {
        button.classList.add('border-t')
        button.classList.add('border-r')
        button.classList.add('border-l')
        button.classList.add('mb-[-1px]')
        button.classList.add('bg-white')
        button.classList.remove('text-gray-400')

      } else {
        button.classList.remove('border-t')
        button.classList.remove('border-r')
        button.classList.remove('border-l')
        button.classList.add('text-gray-400')
        button.classList.remove('mb-[-1px]')
      }
    });
  }

  checkScroll() {
    if (window.scrollY > 0) {
      this.scrollButtonTarget.classList.add("fixed", "top-1", "right-[50%]");
    } else {
      this.scrollButtonTarget.classList.remove("fixed", "top-1", "right-[50%]");
    }
  }

  updateAdvanceActiveState() {
    const advanceAmountString = this.advanceAmountTarget.value;
    const normalizedValue = advanceAmountString.replace(/\./g, '').replace(/,/g, '.');

    const advanceAmount = Number(normalizedValue);
    const advanceConsumedAmount = parseFloat(this.advanceConsumedAmountTarget.textContent);
    const isActive = advanceAmount > advanceConsumedAmount;

    this.advanceActiveTarget.checked = isActive;
    this.advanceHiddenTarget.value = isActive ? '1' : '0';
  }

  toggleEmailInput() {
    if (this.createAccountTarget.checked) {
      this.emailFieldTarget.classList.remove('hidden')
    } else {
      this.emailFieldTarget.classList.add('hidden')
    }
  }

  validateEmail(event) {
    // Check email validation only if the targets exist
    if (this.hasEmailFieldTarget && this.hasCreateAccountTarget) {
      const emailInput = this.emailFieldTarget.querySelector('input');
      if (this.createAccountTarget.checked && !emailInput.value.trim()) {
        event.preventDefault();
        alert('You have selected "Create Account." Please enter an email address to proceed.');
      }
    }
  }

  updatePercentage(event) {
    const formContainer = event.currentTarget.closest('.m-2');

    const buttonScaling = formContainer.querySelector('[data-operatorinfo-target="buttonScaling"]');
    const buttonScalingBasis = formContainer.querySelector('[data-operatorinfo-target="buttonScalingBasis"]');
    const rsPercentage = formContainer.querySelector('[data-operatorinfo-target="rsPercentage"]');
    const initialAmountInput = formContainer.querySelector('[data-operatorinfo-target="initialAmount"]');
    const finalAmountInput = formContainer.querySelector('[data-operatorinfo-target="finalAmount"]');

    if (!buttonScaling || !buttonScalingBasis || !rsPercentage || !initialAmountInput || !finalAmountInput) {
      console.error('Algunos elementos requeridos no están presentes');
      return;
    }

    const initialAmount = parseFloat(initialAmountInput.value.replace(/\./g, '').replace(',', '.'));
    const finalAmount = parseFloat(finalAmountInput.value.replace(/\./g, '').replace(',', '.'));

    if (isNaN(initialAmount) || isNaN(finalAmount)) {
      rsPercentage.value = '';
      rsPercentage.classList.remove('bg-gray-300');
      return;
    }

    if (initialAmount >= 0 && initialAmount < finalAmount && finalAmount <= 100000) {
      rsPercentage.value = '10';
      rsPercentage.classList.add('bg-gray-300');
    } else if (initialAmount > 100000 && initialAmount < finalAmount && finalAmount <= 200000) {
      rsPercentage.value = '9';
      rsPercentage.classList.add('bg-gray-300');
    } else {
      rsPercentage.value = '';
      rsPercentage.classList.remove('bg-gray-300');
    }
  }

  isEditMode() {
    return window.location.pathname.includes('/edit');
  }

  initializeAllForms() {
    const forms = this.element.querySelectorAll('.form_scaling');
    forms.forEach(form => {
      this.setInitialButtonState(form);
    });
  }

  setInitialButtonState(form) {
    const inputScaling = form.querySelector('[data-operatorinfo-target="inputScaling"]');
    const inputScalingBasis = form.querySelector('[data-operatorinfo-target="inputScalingBasis"]');
    const buttonScalings = form.querySelectorAll('[data-operatorinfo-target="buttonScaling"]');
    const buttonScalingBasis = form.querySelectorAll('[data-operatorinfo-target="buttonScalingBasis"]');

    this.updateButtonState(buttonScalings, inputScaling ? inputScaling.value : null);
    this.updateButtonState(buttonScalingBasis, inputScalingBasis ? inputScalingBasis.value : null);
  }

  updateButtonState(buttons, selectedValue) {
    buttons.forEach(button => {
      if (button.dataset.state === selectedValue) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.add('bg-white', 'text-green-mga');
        button.classList.remove('bg-green-mga', 'text-white');
      }
    });
  }
}
